import { Helmet } from "react-helmet-async";

export default function SEO({ title, description, canonical, type = "website", image }) {
  const siteTitle = "Amar Preet Scaffolding";
  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} | Premium Scaffolding & Shuttering Rental India`;
  const url = canonical ? `https://www.amarpreet.in${canonical}` : "https://www.amarpreet.in/";
  const ogImage = image || "https://www.amarpreet.in/images/aps-logo.png";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteTitle} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="400" />
      <meta property="og:image:height" content="400" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
